import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#607D8B",
		d: "M14.781 2.074c.465-.574.055-1.449-.683-1.449H1.875c-.738 0-1.148.875-.684 1.45l5.059 6.07v2.543c0 .218.082.437.273.546l2.188 1.532a.66.66 0 0 0 1.039-.547V8.145l5.031-6.07Z"
	})]
});
const ForwardRef = forwardRef(SvgFilterFilled);
export { ForwardRef as ReactComponent };
